import { NetworkStatus, useQuery } from '@apollo/client';
import { useCallback } from 'react';

import { useAscContext } from '@neo.tax/asc/context';
import {
  downloadFileByUrl,
  GetAscWageReportQuery,
  GetAscWageReportQueryVariables,
  GET_ASC_WAGE_REPORT,
} from '@neo.tax/shared';

export const useGetAscWageReport = (): {
  download: () => Promise<void>;
  loading: boolean;
} => {
  const { fiscalYearId, periodName } = useAscContext();
  const { networkStatus, refetch } = useQuery<GetAscWageReportQuery, GetAscWageReportQueryVariables>(
    GET_ASC_WAGE_REPORT,
    { fetchPolicy: 'network-only', skip: true },
  );

  const download = useCallback(async (): Promise<void> => {
    const { data } = await refetch({ fiscalYearId, periodName });
    const { signedUrl } = data.getAscWageReport;
    if (!signedUrl) {
      return;
    }
    // The file name here is irrelevant. The file will be downloaded as the original name uploaded to GCP Cloud Storage.
    downloadFileByUrl(signedUrl, 'asc-wage-report.xlsx');
  }, [refetch, fiscalYearId, periodName]);

  return {
    download,
    loading: networkStatus === NetworkStatus.loading,
  };
};
